import { render, staticRenderFns } from "./SubmitReport.vue?vue&type=template&id=4c893c1e&scoped=true&"
import script from "./SubmitReport.vue?vue&type=script&lang=js&"
export * from "./SubmitReport.vue?vue&type=script&lang=js&"
import style0 from "./SubmitReport.vue?vue&type=style&index=0&id=4c893c1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c893c1e",
  null
  
)

export default component.exports